module.exports = __webpack_public_path__ + "static/img/6.69811fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/eng/6.png
// module id = 4ZNC
// module chunks = 0